export default "<div [ngClass]=\"{'main':!isFullPage}\">\n  <app-bar *ngIf=\"!isFullPage\"></app-bar>\n  <router-outlet></router-outlet>\n</div>\n\n"